import styled from 'styled-components'
import { useMemo } from 'use-memo-one'

import { AppDataTable } from '@root/features/app-data-table/app-data-table'

import { reatomWalletAssetsTable } from '../../atoms/reatom-wallet-assets-table'

import type {
  WalletAssetsColumnId,
  WalletAssetsTableContext,
} from '../../atoms/reatom-wallet-assets-table'
import type { WalletAssetModel, WalletModel } from '@root/entities/wallet'

export const WALLET_ASSET_TABLE_ROW_HEIGHT = 38
export const WALLET_ASSET_TABLE_HEADER_HEIGHT = 32

type WalletAssetTableProps = {
  wallet: WalletModel
}

export const WalletAssetTable: React.FC<WalletAssetTableProps> = ({
  wallet,
}) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const model = useMemo(() => reatomWalletAssetsTable({ wallet }), [wallet])
  const context = useMemo(() => ({ wallet }), [wallet])
  return (
    <Table
      model={model}
      context={context}
      rowHeight={WALLET_ASSET_TABLE_ROW_HEIGHT}
    />
  )
}

const Table = styled(
  AppDataTable<
    WalletAssetModel,
    WalletAssetsColumnId,
    WalletAssetsTableContext
  >,
)`
  border-bottom: 1px solid var(--backgroundA-4);

  && {
    --data-table-header-bg: transparent;
    --data-table-header-color: var(--textA-6);
    --data-table-header-color-hover: var(--textA-8);
    --data-table-row-border-color: var(--backgroundA-2);
    --data-table-row-even-bg: transparent;
    --data-table-row-odd-bg: transparent;
  }
  & *[data-table-header='true'] {
    border-bottom: 1px solid var(--background-2);
  }
`
